<template>
  <div id='teamForm'>
    <Form :model="formItem" :label-width="100" ref="formValidate" :rules="ruleValidate">
      <div class="content-title">
        <Icon type="home"></Icon>公司
        <div class="border"></div>
      </div>
      <FormItem label="客戶代號" prop="code">
          <Input v-model="formItem.code" placeholder="Enter something..." :disabled="disabledCreate"></Input>
      </FormItem>
      <FormItem label="車隊名稱" prop="name">
          <Input v-model="formItem.name" placeholder="Enter something..." :disabled="disabledEdit && disabledCreate"></Input>
      </FormItem>
      <FormItem label="公司名稱" prop="company_name">
          <Input v-model="formItem.company_name" placeholder="Enter something..." :disabled="disabledEdit && disabledCreate"></Input>
      </FormItem>
      <FormItem label="聯絡電話" prop="phone">
          <Input v-model="formItem.phone" placeholder="Enter something..." :disabled="disabledEdit && disabledCreate"></Input>
      </FormItem>
      <FormItem label="傳真" prop="fax">
          <Input v-model="formItem.fax" placeholder="Enter something..." :disabled="disabledEdit && disabledCreate"></Input>
      </FormItem>
      <FormItem label="收款方式" prop="payment_method">
          <Input v-model="formItem.payment_method" placeholder="Enter something..." :disabled="disabledEdit && disabledCreate"></Input>
      </FormItem>
      <FormItem label="預結帳日" prop="closing_date">
          每月　　　<InputNumber :max="31" :min="1" v-model="formItem.closing_date" :disabled="disabledEdit && disabledCreate"></InputNumber>　日
      </FormItem>
      <FormItem label="統一編號" prop="tax_id">
          <Input v-model="formItem.tax_id" placeholder="Enter something..." :disabled="disabledEdit && disabledCreate"></Input>
      </FormItem>
      <FormItem label="地址" prop="address">
          <Input v-model="formItem.address" placeholder="Enter something..." :disabled="disabledEdit && disabledCreate"></Input>
      </FormItem>
      <FormItem label="備註">
          <Input v-model="formItem.note" placeholder="Enter something..." :disabled="disabledEdit && disabledCreate"></Input>
      </FormItem>
      <FormItem label="聯絡人">
          <Input v-model="formItem.contact_person" placeholder="Enter something..." :disabled="disabledEdit && disabledCreate"></Input>
      </FormItem>
      <FormItem label="mongo_collection" prop="mongo_collection">
          <Input v-model="formItem.mongo_collection" placeholder="Enter something..." :disabled="disabledEdit && disabledCreate"></Input>
      </FormItem>
    <!-- </Form> -->
    <div class="content-title">
      <Icon type="person" class="icon"></Icon>管理者
      <div class="border"></div>
    </div>
    <!-- <Form :model="formItem" :label-width="80"> -->
      <FormItem label="帳號" prop="manager_account">
          <Input v-model="formItem.manager_account" placeholder="Enter something..." :disabled="disabledCreate"></Input>
      </FormItem>
      <FormItem label="密碼" prop="manager_password">
          <Input v-model="formItem.manager_password" placeholder="Enter something..." :disabled="disabledEdit && disabledCreate"></Input>
      </FormItem>
      <FormItem label="名稱" prop="manager_name">
          <Input v-model="formItem.manager_name" placeholder="Enter something..." :disabled="disabledEdit && disabledCreate"></Input>
      </FormItem>
      <FormItem label="職位" prop="manager_position">
          <Input v-model="formItem.manager_position" placeholder="Enter something..." :disabled="disabledEdit && disabledCreate"></Input>
      </FormItem>
      <FormItem label="權限">
          <Input v-model="formItem.manager_permission" placeholder="Enter something..." disabled></Input>
      </FormItem>
      <FormItem label="電話" prop="manager_phone">
          <Input v-model="formItem.manager_phone" placeholder="Enter something..." :disabled="disabledEdit && disabledCreate"></Input>
      </FormItem>
      <FormItem label="信箱" prop="manager_email">
          <Input v-model="formItem.manager_email" placeholder="Enter something..." :disabled="disabledEdit && disabledCreate"></Input>
      </FormItem>
      <!-- <FormItem label="公司">
          <Input v-model="formItem.manager_company" placeholder="Enter something..."></Input>
      </FormItem> -->
      <FormItem label="備註">
          <Input v-model="formItem.manager_note" placeholder="Enter something..." :disabled="disabledEdit && disabledCreate"></Input>
      </FormItem>
    </Form>
    
  </div>
</template>

<script>
import { API } from "@/assets/config";

export default {
  name: "teamForm",
  data() {
    return {
      id: this.$route.params.id,
      disabledEdit: true,
      disabledCreate: true,
      formItem: {
        "name": "",
        "address": "",
        "phone": "",
        "fax": "",
        "code": "",
        "closing_date": 1,
        "tax_id": "",
        "payment_method": "",
        "note": "",
        "contact_person": "",
        "is_block": false,
        "company_name": "",
        "mongo_collection": "",
        "createdAt": "",
        "updatedAt": "",
        "manager_position": "",
        "manager_phone": "",
        "manager_permission": 0,
        "manager_account": "",
        "manager_password": "",
        "manager_note": "",
        "manager_email": "",
        "manager_company": "",
        "manager_name": ""
      },
      ruleValidate: {
        name: [{ required: true, trigger: 'blur' }],
        "address": [{ required: true, trigger: 'blur' }],
        "phone": [{ required: true, trigger: 'blur' }],
        "fax": [{ required: true, trigger: 'blur' }],
        "code": [{ required: true, trigger: 'blur' }],
        "closing_date": [{ required: true,type: "number", trigger: 'blur' }],
        "tax_id": [{ required: true, trigger: 'blur' }],
        "payment_method": [{ required: true, trigger: 'blur' }],
        "note": "",
        "contact_person": "",
        "manager_position": [{ required: true, trigger: 'blur' }],
        "manager_phone": [{ required: true, trigger: 'blur' }],
        "manager_permission": 0,
        "manager_account": [{ required: true, trigger: 'blur' }],
        "manager_password": [{ required: true, trigger: 'blur' }],
        "manager_note": "",
        "manager_name": [{ required: true, trigger: 'blur' }],
        manager_email: [
          { required: true, message: 'Mailbox cannot be empty', trigger: 'blur' },
          { type: 'email', message: 'Incorrect email format', trigger: 'blur' }
        ],
      }
    };
  },
  created() {
    if(this.id)
      this.getTeam()
    else
      this.openCreate()
  },
  methods: {
    async getTeam() {
      let res = await this.axios.get(API.teams + this.id)
      console.log(res)
      this.formItem = res.data
    },
    getFormItem() {
      return this.formItem
    },
    openEdit () {
      this.disabledEdit = false
    },
    closeEdit () {
      this.disabledEdit = true
    },
    openCreate () {
      this.disabledCreate = false
    },
    validate () {
      let result
      this.$refs['formValidate'].validate((valid) => {
        result = valid
        if (!valid)
          this.$Message.error('Fail!');
      })
      return result
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

#teamForm {
  .ivu-form {
    width: 70%;
    margin: 0px auto;
    .ivu-input,.ivu-input-number-input {
      color: rgba(0, 0, 0, 1);
    }
    .ivu-input:disabled,.ivu-input-number-input:disabled {
      color: rgba(0, 0, 0, 0.7);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/team/teamForm.vue